function addTwclid() {
  var twclidFormFields = ["event_booking_twclid", "issue_twclid"]; // all possible twclid form field ids here
  var currTwclidFormField;

  twclidFormFields.forEach(function (field) {
    if (document.getElementById(field)) {
      currTwclidFormField = document.getElementById(field);
    }
  });

  var twclid = window.twclid;

  if (currTwclidFormField && twclid) {
    currTwclidFormField.value = twclid;
  }
}

document.addEventListener("turbo:load", addTwclid);